module.exports = __webpack_public_path__ + "img/ic_room_store_bottom_item_img2.2711a7b2.png";